// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"7e62f784","453":"686516f4"}[chunkId] + ".chunk.js";
};